import { render } from "./CreateTextFeatureModal.vue?vue&type=template&id=8aa5e60e"
import script from "./CreateTextFeatureModal.vue?vue&type=script&lang=js"
export * from "./CreateTextFeatureModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "8aa5e60e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8aa5e60e', script)) {
    api.reload('8aa5e60e', script)
  }
  
  module.hot.accept("./CreateTextFeatureModal.vue?vue&type=template&id=8aa5e60e", () => {
    api.rerender('8aa5e60e', render)
  })

}

script.__file = "resources/js/Pages/Station/Partials/Features/Text/CreateTextFeatureModal.vue"

export default script